export default __webpack_public_path__ + "static/media/Ideia.9c6cf6ba.svg";